// extracted by mini-css-extract-plugin
export default {"template-helper-block":"template-helper-block--964c26","templateHelperBlock":"template-helper-block--964c26"};